<template>
  <a-card :bordered="false">
    <div class="banner_container gggl">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="文章标题">
                <a-input
                  placeholder="请输入文章标题"
                  v-model="articleTitle"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8" style="float: left; overflow: hidden">
              <span
                style="text-align: right"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
          <!-- <a-row>
          <a-col span="24" class="banner_btns">
            <a-button type="primary" @click="handleAdd()">
              <a-icon type="plus" />新增
            </a-button>
            <a-dropdown v-if="selectedRowKeys.length > 0">
              <a-menu slot="overlay">
                <a-menu-item @click="puDetele(selectedRowKeys)">
                  <a-icon type="primary" />批量删除</a-menu-item
                >
              </a-menu>
              <a-button style="margin-left: 8px">
                批量操作
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </a-col>
        </a-row> -->
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button
          @click="handleAdd({ articleType: articleType })"
          type="primary"
          icon="plus"
          >新增</a-button
        >
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="puDetele(selectedRowKeys)"
              ><a-icon type="delete" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <!-- 清空 -->
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <!-- 表格 -->
      <a-table
        ref="tableSelect"
        :columns="columns"
        rowKey="id"
        :scroll="{ x: 1240 }"
        bordered
        :data-source="dataSource"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :loading="loading"
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="pic" slot-scope="text, record">
          <img :src="record.pic" alt="" style="width: 80px; height: 40px" />
        </template>
        <template slot="statusFlg" slot-scope="text">
          <span v-if="text == 0">待发布</span>
          <span v-if="text == 1">已发布</span>
          <span v-if="text == 2">已过期</span>
        </template>
        <template slot="publish" slot-scope="text, record">
          <a-switch
            v-model="record.statusFlg"
            checked-children="已发布"
            un-checked-children="未发布"
            :disabled="record.isReview == 1 ? false : true"
            @click="(checked) => handlePublishArticle(checked, record)"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="handleEdit(record, record.id)">编辑</a>
          <a-divider type="vertical" />
          <a
            href="javascript:;"
            :disabled="record.status == 0 ? false : true"
            @click="onDelete(record.id)"
            >删除</a
          >
          <a-divider type="vertical" />
          <a
            href="javascript:;"
            :disabled="
              record.isReview == 0 || record.isReview == 2 ? false : true
            "
            @click="onReview(record)"
            >审核</a
          >
          <a-divider type="vertical" />
          <a href="javascript:;" @click="reviewModal(record)">预览</a>
        </template>
      </a-table>
      <notice-manage-modal
        :columnChannel="columnChannel"
        :fundList="fundList"
        ref="modalForm"
        @ok="modalFormOk"
      ></notice-manage-modal>

      <a-modal
        title="审核"
        :visible="showReview"
        :width="800"
        @cancel="showReview = false"
        @ok="handalExamine"
      >
        <a-radio-group v-model="examineFlg" @change="examineFlgChange">
          <a-radio :value="1">审核通过</a-radio>
          <a-radio :value="2">审核驳回</a-radio>
        </a-radio-group>
        <a-textarea
          style="margin-top: 20px"
          placeholder="请输入理由"
          v-model="reason"
          :max-length="100"
          :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-modal>

      <Preview ref="previewModal" :type="'0'" />
    </div>
  </a-card>
</template>

<script>
import { setColumnDeleteBatch, queryByFundCode } from '@/api/api';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import noticeManageModal from './modules/noticeManageModal';
import Preview from '@/components/common/Preview';
import { getAction, postAction, postTag } from '@/api/manage';

const columns = [
  {
    align: 'center',
    title: '文章标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    width: 150,
  },
  {
    align: 'center',
    title: '上架渠道栏目',
    dataIndex: 'channelColumnList',
    ellipsis: true,
    width: 150,

    customRender: (text) => {
      if (!text) {
        return '--';
      }
      let str = [];
      text.forEach((item) => {
        str.push(item.columnName);
      });
      return str.length > 0 ? str.join(',') : '--';
    },
  },
  {
    align: 'center',
    title: '作者',
    dataIndex: 'author',
    width: 100,
    customRender: (text) => {
      return !text || text == '' ? '--' : text;
    },
    ellipsis: true,
  },
  {
    align: 'center',
    title: '创建时间',
    dataIndex: 'createTime',
    ellipsis: true,
    // width: 200
  },
  {
    align: 'center',
    title: '审核状态',
    dataIndex: 'isReview',
    customRender: (text) => {
      return text == 0 ? '待审核' : text == 1 ? '审核通过' : '审核驳回';
    },
    width: 100,
  },

  {
    align: 'center',
    title: '理由',
    dataIndex: 'reason',
    ellipsis: true,
    customRender: (text) => {
      return !text || text == '' ? '--' : text;
    },
  },
  {
    align: 'center',
    title: '发布状态',
    width: 100,
    dataIndex: 'status',
    scopedSlots: {
      customRender: 'statusFlg',
    },
  },
  {
    align: 'center',
    title: '是否发布',
    dataIndex: 'publish',
    ellipsis: true,
    scopedSlots: {
      customRender: 'publish',
    },
    width: 150,
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    fixed: 'right',
    scopedSlots: {
      customRender: 'operation',
    },
  },
];

export default {
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    noticeManageModal,
    Preview,
  },
  data() {
    return {
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      articleTitle: '',
      columns,
      routerFundCode: '',
      form: this.$form.createForm(this, {
        name: 'advanced_search',
      }),
      selectedRowKeys: [],
      loading: false,
      columnChannel: [],
      queryColumnChannel: [],
      fundList: {},
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/content/article/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/content/article/del',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/delBatch',
        publishArticle:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/put',
        reviewArticle:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/review',
      },
      showReview: false, //审核弹窗
      examineFlg: 1, //1-审核通过 2-审核拒绝
      reason: '', //审核拒绝理由
      currentExamine: {}, //当前要审核的数据
      articleType: 1, //1、文章类型 2、课程类型
    };
  },
  created() {
    this.initData();
    this.loadData();
    //初始化字典配置 在自己页面定义
    this.initDictConfig();
  },
  methods: {
    onReview(record) {
      this.showReview = true;
      this.currentExamine = record;
    },
    examineFlgChange(e) {
      this.examineFlg = e.target.value;
    },
    handlePublishArticle(checked, record) {
      postAction(this.url.publishArticle, {
        id: record.id,
        status: checked ? 1 : 0,
      }).then((res) => {
        if (res.success) {
          this.loadData(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handalExamine() {
      if (this.examineFlg == '') {
        this.$message.warning('请选你要审核的状态');
      }
      postAction(this.url.reviewArticle, {
        id: this.currentExamine.id,
        review: this.examineFlg,
        reason: this.reason == '' ? null : this.reason,
      }).then((res) => {
        if (res.success) {
          this.showReview = false;
          this.loadData(1);
          this.reason = '';
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    puDetele(ids) {
      this.$confirm({
        title: '确认',
        content: '确定要批量删除吗?',
        onOk: () => {
          postAction(this.url.deleteBatch, {
            ids: ids.join(','),
          }).then((res) => {
            if (res.success) {
              this.$message.success(res.message);
              this.loadData(1);
            } else {
              this.$message.error(res.message);
            }
          });
        },
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipagination = pagination;
      this.loadData({
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      // this.routerFundCode = this.$route.params.fundCode;
      // var params = this.getQueryParams(); //查询条件
      // if (this.routerFundCode) {
      //   params.fundCode = this.routerFundCode;
      // }
      let params = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        title: this.articleTitle,
        articleType: 1, //1、文章类型
      };
      this.loading = true;
      postTag(this.url.list, params).then((res) => {
        this.loading = false;
        this.dataSource =
          res.result && res.result.records ? res.result.records : [];
        this.dataSource.forEach((item) => {
          item.statusFlg = item.status == 0 ? false : true;
        });
        this.ipagination.total = res.result.total;
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
    initData() {
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
        { channelCode: 'pc_service' }
      ).then((res) => {
        if (res.success) {
          this.columnChannel = res.result;
          this.queryColumnChannel = JSON.parse(JSON.stringify(res.result));
          this.handleColumnValue(this.queryColumnChannel);
        }
      });
      queryByFundCode().then((res) => {
        if (res.success) {
          this.fundList = res.result.records;
          console.log(res, '关联产品');
        }
      });
    },
    handleColumnValue(queryColumnChannel) {
      for (let index in queryColumnChannel) {
        let item = queryColumnChannel[index];
        item.value = item.code;
        if (item.children && item.children.length > 0) {
          this.handleColumnValue(item.children);
        }
      }
    },
    // 删除
    onDelete(id) {
      let that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    searchReset() {
      this.articleTitle = '';
      this.loadData();
    },
    reviewModal(record) {
      this.$refs.previewModal.dataSource = record.channelColumnList;
      this.$refs.previewModal.visible = true;
    },
  },
};
</script>

<style scoped lang="less">
.banner_container {
  background: #fff;
  .table-operator {
    margin-bottom: 8px;
  }
  .table-operator {
    .ant-btn {
      margin: 0 8px 8px 0;
    }
  }
  .lm {
    z-index: 999;
  }

  .banner_title {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    font-size: 22px;
    color: #333;
    margin-bottom: 20px;
  }

  .banner_btns {
    margin-bottom: 20px;

    .ant-btn {
      margin-right: 10px;
    }
  }

  .ant-table-wrapper {
    margin-bottom: 30px;
  }

  .bannerImg {
    display: flex;

    .img_item {
      width: 250px;
      height: 170px;

      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
<style lang="less">
.gggl {
  .ant-select-open .ant-select-selection,
  .lm .ant-select-selection--multiple {
    max-height: 104px;
    overflow-y: scroll;
  }
}
.edit-upload {
  margin-left: 136px;
  margin-bottom: 23px;

  .pdf {
    color: #999;
    margin-left: 10px;
  }
}
</style>
